import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useMutation } from '@apollo/client';
import { SIGNUP } from "../mutations/userMutations";

import { useAuthContext } from './useAuthContext';

export const useSignup = () => {
  const [fullname, setFullname] = useState('')
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(null)
  
  const { dispatch } = useAuthContext()
  const navigate = useNavigate()

  const [signupUser] = useMutation(SIGNUP, {
    variables: { fullname, username, email, password },
    onCompleted: ({ signup }) => {
      dispatch({ type: 'LOGIN', payload: signup })
      localStorage.setItem('token', JSON.stringify(signup.token))
      
      let user = signup
      user.token = null
      dispatch({ type: 'GET_ME', payload: user })
      const id = user.id
      localStorage.setItem('authUser', id)

      navigate('/')
    },
    onError: (error) => {
      setIsLoading(false)
      setError(error.message)
    }
  })

  const signup = async (fullname, username, email, password) => {
    setIsLoading(true)
    setError(null)

    await setFullname(fullname)
    await setUsername(username)
    await setEmail(email)
    await setPassword(password)

    if (fullname === '' || username === '' || email === '' || password === '') {
      setError('Please fill in all fields')
      setIsLoading(false)

      return
    }

    await signupUser(fullname, username, email, password)

    setIsLoading(false)
  }

  return { signup, isLoading, error }
}
